import { COMPOSE_TABS } from '../components/MediaSystem/consts';

export const ALT_TEXT_SUPPORTED_TABS: composeTabs[] = [
  COMPOSE_TABS.MESSAGE,
  COMPOSE_TABS.BLUESKY,
  COMPOSE_TABS.FACEBOOK,
  COMPOSE_TABS.INSTAGRAM,
  COMPOSE_TABS.LINKEDIN,
  COMPOSE_TABS.TWITTER,
  COMPOSE_TABS.THREADS,
];

export const VIDEO_SETTINGS_SUPPORTED_TABS: string[] = [
  COMPOSE_TABS.MESSAGE,
  COMPOSE_TABS.FACEBOOK,
  COMPOSE_TABS.INSTAGRAM,
  COMPOSE_TABS.LINKEDIN,
  COMPOSE_TABS.TIKTOK,
  COMPOSE_TABS.GROUP,
  COMPOSE_TABS.YOUTUBE,
];

export const FIRST_COMMENT_SUPPORTED_TABS: string[] = [COMPOSE_TABS.FACEBOOK, COMPOSE_TABS.INSTAGRAM, COMPOSE_TABS.LINKEDIN, COMPOSE_TABS.TIKTOK];

export const FIRST_COMMENT_LIMITS = {
  [COMPOSE_TABS.FACEBOOK]: 8000,
  [COMPOSE_TABS.INSTAGRAM]: 2200,
  [COMPOSE_TABS.LINKEDIN]: 20000,
  [COMPOSE_TABS.TIKTOK]: 150,
};
